import angular from 'angular';
import _ from 'lodash';
import { CANDIDATE_FEEDBACK_STATUSES } from '../../recruiter/constants/feedback';

export const FeedbackFilterService = () => {
    const getCounters = (candidates) => {
        return (candidates || []).reduce((countResult, candidate) => {
            const {
                isGoodFit,
                isNotFit,
                isPendingFeedbackStatus
            } = getCandidateFeedbackInfo(candidate);

            if (isGoodFit) {
                return {
                    ...countResult,
                    goodFit: countResult.goodFit + 1,
                };
            }

            if (isNotFit) {
                return {
                    ...countResult,
                    notFit: countResult.notFit + 1,
                };
            }

            if (isPendingFeedbackStatus) {
                return {
                    ...countResult,
                    nonRated: countResult.nonRated + 1,
                };
            }
            return countResult;
        }, {
            all: candidates.length,
            nonRated: 0,
            goodFit: 0,
            notFit: 0,
        });
    };

    const getCandidateFeedbackInfo = (candidate) => {
        const feedbackStatus = _.get(candidate, 'workflow.feedback.status');
        const feedbackGrade = _.get(candidate, 'workflow.feedback.grades.0.grade');

        return {
            isNotFit: feedbackGrade === 0,
            isGoodFit: feedbackGrade === 1,
            isPendingFeedbackStatus: feedbackStatus === CANDIDATE_FEEDBACK_STATUSES.PENDING,
            isAcceptedFeedbackStatus: feedbackStatus === CANDIDATE_FEEDBACK_STATUSES.ACCEPTED,
            isReadyForSendStatus: feedbackStatus === CANDIDATE_FEEDBACK_STATUSES.READY_FOR_SEND,
        };
    };

    const sortByName = (candidates) => {
        return (candidates || []).sort((candidate1, candidate2) => {
            const candidateName1 = _.get(candidate1, 'name') || _.get(candidate1, 'fullName');
            const candidateName2 = _.get(candidate2, 'name') || _.get(candidate2, 'fullName');

            return candidateName1 > candidateName2 ? 1 : -1;
        });
    };

    const sortByDateAndName = (candidates) => {
        return (candidates || []).sort((candidate1, candidate2) => {
            const feedbackDate1 = getOnlyDate(candidate1);
            const feedbackDate2 = getOnlyDate(candidate2);

            if (feedbackDate1 && feedbackDate2) {
                const timestamp1 = feedbackDate1.getTime();
                const timestamp2 = feedbackDate2.getTime();
                if (timestamp1 === timestamp2) {
                    const candidateName1 = _.get(candidate1, 'name') || _.get(candidate1, 'fullName');
                    const candidateName2 = _.get(candidate2, 'name') || _.get(candidate2, 'fullName');

                    return candidateName1 > candidateName2 ? 1 : -1;
                }

                return timestamp1 > timestamp2 ? -1 : 1;
            }

            return 0;
        });
    };

    const getFilteredNonRatedCandidates = (candidates) => {
        const filteredCandidates = (candidates || []).filter((candidate) => {
            const {isPendingFeedbackStatus} = getCandidateFeedbackInfo(candidate);

            return isPendingFeedbackStatus;
        });

        return sortByName(filteredCandidates);
    };

    const getFilteredGoodFitCandidates = (candidates) => {
        const filteredCandidates = (candidates || []).filter((candidate) => {
            const {isAcceptedFeedbackStatus, isGoodFit} = getCandidateFeedbackInfo(candidate);

            return isAcceptedFeedbackStatus && isGoodFit;
        });

        return sortByDateAndName(filteredCandidates);
    };

    const getFilteredNotFitCandidates = (candidates) => {
        const filteredCandidates = (candidates || []).filter((candidate) => {
            const {isAcceptedFeedbackStatus, isNotFit} = getCandidateFeedbackInfo(candidate);

            return isAcceptedFeedbackStatus && isNotFit;
        });

        return sortByDateAndName(filteredCandidates);
    };

    const getFilteredAllCandidates = (candidates) => {
        const {notSent, nonRated, rated} = (candidates || []).reduce((result, candidate) => {
            const {isPendingFeedbackStatus, isReadyForSendStatus} = getCandidateFeedbackInfo(candidate);

            if (isReadyForSendStatus) {
                return {
                    ...result,
                    notSent: [...result.notSent, candidate],
                };
            }

            if (isPendingFeedbackStatus) {
                return {
                    ...result,
                    nonRated: [...result.nonRated, candidate],
                };
            }

            return {
                ...result,
                rated: [...result.rated, candidate],
            };
        }, {notSent: [], nonRated: [], rated: []});

        return [
            ...sortByName(notSent),
            ...sortByName(nonRated),
            ...sortByDateAndName(rated),
        ];
    };

    const getOnlyDate = (candidate) => {
        const timestamp = _.get(candidate, 'workflow.feedback.timestamp');

        if (!timestamp) {
            return null;
        }

        const date = new Date(timestamp);
        const day = date.getDate();
        const month = date.getMonth();
        const year = date.getFullYear();
        const newDate = new Date();

        newDate.setMilliseconds(0);
        newDate.setSeconds(0);
        newDate.setMinutes(0);
        newDate.setHours(0);
        newDate.setFullYear(year, month, day);

        return newDate;
    };

    return {
        getCounters,
        getCandidateFeedbackInfo,
        sortByName,
        sortByDateAndName,
        getFilteredNonRatedCandidates,
        getFilteredGoodFitCandidates,
        getFilteredNotFitCandidates,
        getFilteredAllCandidates,
    };
};


angular.module('TALENYA-FE').factory('FeedbackFilterService', FeedbackFilterService);
